import React from 'react';

import { useTranslation } from 'hooks';
import InformationIcon from 'BookingFlow/components/InformationIcon';

export default function Price({
	currency,
	amount,
	feesDisclaimer,
	priceLabel,
	children,
	showFeeDisclaimerIcon = false,
	onFeeDisclaimerInfoClick,
}) {
	const { t, formatPrice, locale } = useTranslation();
	const shouldShowFeeDisclaimerIcon =
		showFeeDisclaimerIcon && typeof onFeeDisclaimerInfoClick === 'function';

	return (
		<div className="price">
			<div className="nightly-rate">
				<div className="price-primary-row">
					<span className="from">{t('From')}</span>
					<span className="fullprice">
						{formatPrice({
							currency,
							value: amount.withoutDecimal,
							decimalPlaces: 0,
							locale,
						})}
					</span>
					{shouldShowFeeDisclaimerIcon && (
						<button
							type="button"
							className="btn-link fee-disclaimer-info-button"
							onClick={onFeeDisclaimerInfoClick}
							aria-label={t('View mandatory fee information')}
							aria-haspopup="dialog"
						>
							<InformationIcon />
						</button>
					)}
				</div>
				<div className="night">{t(priceLabel)}</div>
				{feesDisclaimer && (
					<div className="resort-fee">{t(feesDisclaimer.key, feesDisclaimer.params)}</div>
				)}
				{children}
			</div>
		</div>
	);
}
